import React from 'react';
import { Link } from 'react-router-dom';

export default function ForProfessionals() {
  return (
    <section className="py-24 md:py-32 px-6" style={{ backgroundColor: '#f5f6ed' }}>
      <div className="max-w-5xl mx-auto">
        <div className="grid lg:grid-cols-[2fr_1fr] gap-12 items-center">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-gray-500">
              For Clinicians & Researchers
            </span>
            <h2 className="text-4xl md:text-5xl font-light mt-4 mb-6 leading-tight">
              Help shape Bloora before it ships.
            </h2>
            <div className="w-20 h-px bg-gray-900 mb-8" />
            <p className="text-lg text-gray-700 leading-relaxed">
              Therapists, psychiatrists, and researchers — your perspective is the
              one we can't simulate. We're inviting a small group of professionals
              to evaluate the clinician-facing side of Bloora, provide direct
              feedback, and influence the system that ends up in front of patients.
            </p>
          </div>

          <div className="flex lg:justify-end">
            <Link to="/early-access" className="btn-primary">
              Join early access →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
